<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    
    <app-selected class="w-full"
            [config]="dataSelected().at(0)"
            (selectValue)="handleValue($event)"
    ></app-selected>

    @for (item of dataInputs(); track $index) {
        <app-input class="w-full"
            [config]="item"
            (submitValue)="handleValue($event)">
        </app-input>
    }

    @for (item of dataSelected().slice(1); track $index) {
        <app-selected class="w-full"
            [config]="item"
            (selectValue)="handleValue($event)"
        ></app-selected>
    }

    <app-profession class="w-full" [defaultValue]="defaultData?.codpro" (valueState)="onProfessionSelected($event)"></app-profession>

</form>